import Vue from 'vue'
import Vuex from 'vuex'

// Import all of our modules so we can define them on our store. Any new
// modules created need to be imported and defined on the store.
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules
})
